var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrectGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47852 10.957C8.47559 10.957 10.957 8.47021 10.957 5.47852C10.957 2.48145 8.47021 0 5.47314 0C2.48145 0 0 2.48145 0 5.47852C0 8.47021 2.48682 10.957 5.47852 10.957ZM4.87158 8.10498C4.68896 8.10498 4.53857 8.02979 4.39893 7.8418L3.05078 6.1875C2.97021 6.08008 2.92188 5.96191 2.92188 5.83838C2.92188 5.59668 3.10986 5.39795 3.35156 5.39795C3.50732 5.39795 3.62549 5.44629 3.75977 5.62354L4.8501 7.03076L7.14355 3.34619C7.24561 3.18506 7.38525 3.09912 7.5249 3.09912C7.76123 3.09912 7.98145 3.26025 7.98145 3.5127C7.98145 3.63086 7.91162 3.75439 7.84717 3.86719L5.32275 7.8418C5.20996 8.01904 5.0542 8.10498 4.87158 8.10498Z",
    fill: "#C2C9D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectGrey);
export default __webpack_public_path__ + "static/media/correct_grey.ce53ead0.svg";
export { ForwardRef as ReactComponent };